import liveUiService from 'live/services/ui'
import AddOnImpl from 'live/api/add-on'

import ParametersButton from './components/ParametersButton'

liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
    new AddOnImpl(() => ParametersButton(false), { order: -20 })
)
